import { render, staticRenderFns } from "./dialog-submit.vue?vue&type=template&id=7ce66327"
import script from "./dialog-submit.vue?vue&type=script&lang=ts"
export * from "./dialog-submit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports